import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function RezervaceHotovo() {
  return (
    <div className="bg-black min-h-[70vh] flex items-center" data-testid="rezervace-hotovo-page">
      <div className="container-kame text-center py-20">
        <CheckCircle2 size={72} className="text-[#B58A50] mx-auto mb-6" />
        <h1 className="font-display text-4xl sm:text-5xl text-white uppercase">Rezervace odeslána</h1>
        <p className="text-white/65 mt-4 max-w-lg mx-auto">
          Děkujeme! Vaši rezervaci jsme přijali. Brzy se vám ozveme s potvrzením.
          V případě dotazů volejte {BRAND.phones[0]}.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" className="btn-gold" data-testid="done-home-btn">Zpět na úvod</Link>
          <Link to="/vozovy-park" className="btn-outline-gold">Prohlédnout další vozy <ArrowRight size={16} /></Link>
        </div>
      </div>
    </div>
  );
}
